import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function challenge() {
  return (
    <section className="challenge_moodbe p-100 text_white">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="my-auto">
            <h2>Challenges & Solutions</h2>
            <p>
              We didn’t encounter many major setbacks while creating MoodBe.
              Ensuring the algorithm accurately matches users based on their
              mood and interests was a technical challenge, but one that enabled
              us to create an innovative and trendy dating app.The market for
              dating apps is extremely competitive, and standing out in the face
              of such intense competition is difficult.
            </p>
            <p>
              But we were able to do that thanks to our creative idea. To create
              an inclusive and comprehensive experience for all kinds of users,
              we developed apps for both iOS and Android, as well as a web app
              and an admin panel for it. This helped us address any challenges
              we faced and enabled us to turn them into opportunities.
            </p>
          </Col>
          <Col
            xs={12}
            md={5}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto offset-xl-2 offset-lg-1 offset-md-1"
          >
            <div className="challenge_img text-center">
              <StaticImage
                src="../../../images/case-studies/moodbe/challenge.webp"
                alt="TekRevol"
                className=""
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={425}
                height={750}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default challenge;
